import { useEffect } from 'react';
import loadScript from 'load-script';

declare global {
  interface Window {
    acsbJS: {
      initialized: boolean;
      init: (config: any) => void;
      restart: () => void;
    };
  }
}

const acsbInitConfig = {
  statementLink: '',
  footerHtml: '',
  hideMobile: true,
  hideTrigger: false,
  language: 'en',
  position: 'right',
  leadColor: '#333333',
  triggerColor: '#757575',
  triggerRadius: '0',
  triggerPositionX: 'right',
  triggerPositionY: 'top',
  triggerIcon: 'people',
  triggerSize: 'small',
  triggerOffsetX: 0,
  triggerOffsetY: 140,
  mobile: {
    triggerSize: 'small',
    triggerPositionX: 'right',
    triggerPositionY: 'top',
    triggerOffsetX: 0,
    triggerOffsetY: 360,
    triggerRadius: '0'
  }
};

const ACCESSIBE_SCRIPT_URL = 'https://acsbapp.com/apps/app/dist/js/app.js';

const useAccessibe = (): void => {
  useEffect(() => {
    loadScript(ACCESSIBE_SCRIPT_URL, (err: string) => {
      if (err) {
        console.log(err);
        return;
      }

      window.acsbJS.init(acsbInitConfig);
    });
  }, []);
};

export default useAccessibe;
